import { render, staticRenderFns } from "./PurchaseGroupAutocomplete.vue?vue&type=template&id=f551d9da&scoped=true&"
import script from "./PurchaseGroupAutocomplete.vue?vue&type=script&lang=ts&"
export * from "./PurchaseGroupAutocomplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f551d9da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
